"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import {cn} from "@/lib/utils";

function Label({
  className,
  children,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "text-primary/70 flex items-center [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:border-transparent [&_svg:not([class*='size-'])]:border-1 shrink-0 [&_svg]:shrink-0 outline-none max-w-full [&>*]:truncate [&_svg:first-child:last-child]:border-0",
        "text-sm gap-1 [&_svg:not([class*='size-'])]:size-4 [&>*:not(svg)]:-my-0.5 [&_svg:first-child]:-ml-0.75 [&_svg:last-child]:-mr-0.75",
        className,
      )}
      {...props}
    >
      {React.Children.map(children, (child) => {
        if (typeof child === "string" && child.trim()) {
          return <span>{child}</span>;
        }

        return child;
      })}
    </LabelPrimitive.Root>
  );
}

export {Label};
